import { EventEmitter } from 'events'

import { createNextState } from '@reduxjs/toolkit'

import AppDispatcher from '../dispatcher'
import {
  isNotificationAction,
  notificationReducer,
} from './notificationReducer'
import { getWiredComposerStore } from '../state/getWiredComposerStore'
import { notificationsSlice } from '../state/slices/notificationsSlice'

const CHANGE_EVENT = 'change'

getWiredComposerStore()

let notificationState = notificationsSlice.getInitialState()

export const NotificationStore = Object.assign({}, EventEmitter.prototype, {
  emitChange: () => NotificationStore.emit(CHANGE_EVENT),
  resetState: () => {
    notificationState = notificationsSlice.getInitialState()
  },
  addChangeListener: (callback: () => void) =>
    NotificationStore.on(CHANGE_EVENT, callback),
  removeChangeListener: (callback: () => void) =>
    NotificationStore.removeListener(CHANGE_EVENT, callback),

  getState: () => notificationState,
  getVisibleNotifications: () => notificationState.visibleNotifications,
  selectVisibleNotifications: (state: typeof notificationState) =>
    state.visibleNotifications,
})

AppDispatcher.register((payload: unknown) => {
  if (
    typeof payload !== 'object' ||
    payload === null ||
    !('action' in payload)
  ) {
    return
  }

  const action = payload.action
  if (!isNotificationAction(action)) return

  const newState = createNextState(notificationState, (draft) =>
    notificationReducer(draft, action),
  )
  const isPayloadInteresting = newState !== notificationState

  notificationState = newState

  if (isPayloadInteresting) NotificationStore.emitChange()
})
